// Import UI assets
import brandFaviconIcon from "components/Icons/appIcon.svg";
import HelpIcon from "components/Icons/help.svg"
import brandLogo from "components/Icons/appIcon.svg";
import brandText from "components/Icons/appText.svg";
import fallbackBanner from "components/Icons/fallbackbanner.png";
import allChatsImage from "components/Icons/AllChats.jpg";
import defaultDisplayPic from "components/Icons/DefaultDP.jpeg";
import noRecordFound from "components/Icons/noRecordFound.jpg";
import whatsappBg from "components/Icons/whatsappbg.png";

// Import icon configurations
import ICON_CONFIG from './iconConfig';

const BRAND_CONFIG = {
  // URLs
  URLS: {
    MAIN: "https://pc.spyone.pl",
    LEGAL: "https://pc.spyone.pl/mul22/legal-info.jsp",
    SUPPORT: "mailto:spyone24@gmail.com",
    PRIVACY_POLICY: "https://pc.spyone.pl/privacy-policy/",
    DIRECTORY: "http://pc.spyone.pl:",
    DIRECTORY_HTTPS: "https://pc.spyone.pl:",
    INSTALL_GUIDE: "https://info.spyonetech.pl/nie-dziala-messenger-keylogger-whatssap-storny-i-nagrywanie-polaczen-dlaczego/",
    PLAY_PROTECT: "https://info.spyonetech.pl/play-protect/",
    RENEW_SUBSCRIPTION: "https://licencja.spyonetech.pl/",    
    LICENSE_TRANSFER: "https://licencja.spyonetech.pl/produkt/przeniesienie-instalacji/",
    POMOC: "https://info.spyonetech.pl/",
    VIDEO_GUIDE: "https://info.spyonetech.pl/obsluga-panelu/",

    // Add all the specific URLs here
    UNINSTALL_WINDOWS: "https://pc.spyone.pl/computer-spy/#uninstallwindows",
    UNINSTALL_GUIDE: "https://pc.spyone.pl/uninstall-guide/",
    PARENT_APP: "https://pc.spyone.pl/real-time-notifier-parent-app.html",
    SIGNUP: "https://pc.spyone.pl/signup/",
    ANDROID10_SETTINGS: "https://spyone24.pl/centrum-wiedzy/",
    COMPUTER_SPY: "https://pc.spyone.pl/computer-spy/",
    MAC_INSTALL_GUIDE: "https://pc.spyone.pl/mac-os-installguide/",
    IOS_INSTALL_GUIDE: "https://pc.spyone.pl/install-guide-ios/",
    GOOGLE_GIF: `/libmanager/images/common/Google.gif`,

    // Add more URLs as needed
    WHATSAPP_WEB_TRACKER: "https://whitelisturl.net/whatsapp-tracker",
  },

  // Paths/Routes (new section)
  PATH: {
    BASE: "/UI",
    DASHBOARD: "/UI/dashboard",
    HOME: "/UI/",
  },

  // Brand Identity
  IDENTITY: {
    NAME: "spyone.pl",
    // SUB_MAIN_CN: "",
    NAME_LOW_CAPS: "spyone",
    CONTACT_SUPPORT: "spyone24@gmail.com"
  },

  // Assets
  ASSETS: {
    LOGOS: {
      favicon: brandFaviconIcon,
      helplogo: HelpIcon,
      main: brandLogo,
      text: brandText,
      fallback: fallbackBanner,
    },
    
    IMAGES: {
      allChats: allChatsImage,
      defaultUser: defaultDisplayPic,
      noRecords: noRecordFound,
      whatsappBackground: whatsappBg,
    },
    
    ICONS: {
      ...ICON_CONFIG // Spread your existing icon config
    }
  },

  // Defaults
  DEFAULTS: {
    USER: {
      avatar: defaultDisplayPic,
      icon: ICON_CONFIG.defaultUserIcon // Add to your icon config if needed
    },
    BACKGROUND: whatsappBg,
  },

  // ✅ Separate section for Date configs
  DATE: {
    IS_DAY_FIRST: true,
    FORMATS: {
      DAY_FIRST: {
        DATE: "DD/MM/YYYY",
        DATE_TIME_PICKER: "dd/MM/yyyy h:mm aa",
        DATE_PICKER: "dd/MM/yyyy",
        DATE_TIME: "dd-MM-yyyy HH:mm",
      },
      MONTH_FIRST: {
        MONTH: "MM/DD/YYYY",
        DATE_TIME_ALT : "MM-dd-yyyy HH:mm",
        MONTH_PICKER: "MM/dd/yyyy",
      },
    },
  },

  // ✅ Google Play Protect–related flags
  PLAY_PROTECT: {
    ENABLED: false,
  },

  //viewtype can be added here later
  VIEW_TYPE: {
    infiniteScrollModeEnabled: false,
  },
};

// Named exports (organized by category)
export const {
  URLS,
  PATH,
  IDENTITY,
  ASSETS,
  DEFAULTS,
  DATE,
  PLAY_PROTECT,
  VIEW_TYPE
} = BRAND_CONFIG;

// Aliases for commonly used values
// export const BRAND_NAME = IDENTITY.NAME;
// export const BRAND_ASSETS = ASSETS;
// export const MAIN_URL = URLS.MAIN;

// Default export
export default BRAND_CONFIG;
